import { render, staticRenderFns } from "./PredefinedMessages.vue?vue&type=template&id=2f458282&"
import script from "./PredefinedMessages.vue?vue&type=script&lang=js&"
export * from "./PredefinedMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports